import styled, { css } from "styled-components";

import colors from "@src/common/styles/colors";
import { DEFAULT_MARGIN_S, DEFAULT_MARGIN_XS } from "@src/common/styles/const";
import { StyledButton } from "@src/modules/shared/components/Button/Button.components";

export const ResultsButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${DEFAULT_MARGIN_S}px;
`;

export const ResultsButton = styled(StyledButton).attrs({
  buttonType: "tertiary",
})<{ isSaveButton?: boolean }>`
  border: 1px solid ${colors.darkBlue};
  height: auto;
  border-radius: 6px;
  padding: ${DEFAULT_MARGIN_XS}px;

  ${(p) =>
    p.isSaveButton &&
    css`
      color: ${colors.white};
      background-color: ${colors.darkBlue};

      &:hover {
        color: ${colors.white};
        background-color: ${colors.darkBlue2};
      }
    `}
`;

export const ResultInput = styled.input.attrs({ type: "number" })<{
  hasError: boolean;
}>`
  padding: ${DEFAULT_MARGIN_S}px;
  border: 1px solid ${(p) => (p.hasError ? colors.red : colors.gray1)};
  border-radius: 6px;
  width: 60px;
  height: 30px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
    border-color: ${colors.darkBlue};
  }

  -moz-appearance: textfield;
`;

export const CustomResultInput = styled.input.attrs({ type: "text" })<{
  hasError: boolean;
}>`
  padding: ${DEFAULT_MARGIN_S}px;
  border: 1px solid ${(p) => (p.hasError ? colors.red : colors.gray1)};
  border-radius: 6px;
  width: 98%;
  height: 30px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
    border-color: ${colors.darkBlue};
  }

  -moz-appearance: textfield;
`;

export const NotesInput = styled.textarea<{
  hasError: boolean;
}>`
  padding: ${DEFAULT_MARGIN_S}px;
  border: 1px solid ${(p) => (p.hasError ? colors.red : colors.gray1)};
  border-radius: 6px;
  width: 98%;
  height: 80px;
  resize: vertical;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${colors.darkBlue};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: none;
`;
